var Haiku = require("@haiku/core");
module.exports = {
  metadata: {
    uuid: "ad18a731-ed77-4085-88b7-419d3fe4f2f8",
    version: "0.0.15",
    organization: "taylor",
    project: "heroine",
    branch: "master",
    folder: "/Users/taylorpoe/.haiku/projects/taylor/heroine",
    username: "taylor+taylor@haiku.ai",
    root: "https://cdn.haiku.ai/e062580c-8941-425f-9ce7-f01d8d3a6bef/07ee961d5f9b270810efecb4f5013685c38388c4/",
    core: "4.2.0",
    title: "Blue",
    type: "haiku",
    relpath: "code/blue/code.js"
  },
  options: {},
  states: {
    lift: { type: "number", value: 20, edited: true },
    finished: { type: "boolean", value: false, edited: true }
  },
  eventHandlers: {
    "haiku:Blue-14f1fd9b04f06ba5": {
      "timeline:Default:0": {
        handler: function(component, element, target, event) {
          this.getDefaultTimeline().pause();
        }
      },
      playBlue: {
        handler: function(component, element, target, event) {
          let frame = this.state.finished ? 90 : 1;
          this.getDefaultTimeline().gotoAndPlay(frame);
        }
      },
      "timeline:Default:180": {
        handler: function(component, element, target, event) {
          this.getDefaultTimeline().pause();
        }
      },
      "timeline:Default:89": {
        handler: function(component, element, target, event) {
          this.getDefaultTimeline().pause();
        }
      }
    },
    "haiku:Slot-5d608acbed0e538b": {}
  },
  timelines: {
    Default: {
      "haiku:Blue-14f1fd9b04f06ba5": {
        "style.WebkitTapHighlightColor": "rgba(0,0,0,0)",
        "style.position": "relative",
        "style.overflowX": "visible",
        "style.overflowY": "visible",
        "sizeAbsolute.x": 349,
        "sizeAbsolute.y": 164,
        "sizeMode.x": 1,
        "sizeMode.y": 1,
        "sizeMode.z": 1,
        "style.transformStyle": { "0": { value: "preserve-3d", edited: true } }
      },
      "haiku:Slot-5d608acbed0e538b": {
        "style.overflow": "visible",
        "style.position": "absolute",
        "style.margin": "0",
        "style.padding": "0",
        "style.border": "0",
        "translation.x": 175.5,
        "translation.y": 53.5,
        "sizeAbsolute.x": 226,
        "sizeMode.x": 1,
        "sizeAbsolute.y": 52,
        "sizeMode.y": 1,
        "style.zIndex": 1,
        opacity: {
          "0": { value: 1, edited: true },
          "517": { value: 0, edited: true }
        },
        "scale.x": {
          "0": { value: 1, edited: true, curve: "easeInBack" },
          "517": { value: 0.1, edited: true }
        },
        "scale.y": {
          "0": { value: 1, edited: true, curve: "easeInBack" },
          "517": { value: 0.1, edited: true }
        }
      },
      "haiku:Group-e0ec0adc46792211": {
        fillRule: "nonzero",
        stroke: "none",
        strokeWidth: 1,
        fill: "none",
        "translation.x": -3,
        "translation.y": -7
      },
      "haiku:slot-e4e182e2aa738bd6": {
        fill: "#1B2226",
        x: 3,
        y: 7,
        width: 226,
        height: 52,
        rx: 10
      },
      "haiku:Wire-731cb434286072ba": {
        "style.overflow": "visible",
        "sizeMode.x": 1,
        "style.margin": "0",
        "style.padding": "0",
        "style.border": "0",
        "translation.x": 179.5,
        "style.position": "absolute",
        "sizeAbsolute.x": 216,
        "translation.y": 53,
        "sizeAbsolute.y": 31,
        "sizeMode.y": 1,
        "style.zIndex": 6,
        "translation.z": {
          "0": {
            value: Haiku.inject(function(lift) {
              return lift - 10;
            }, "lift"),
            edited: true
          }
        },
        opacity: {
          "0": { value: 0, edited: true },
          "517": { value: 1, edited: true }
        },
        "scale.x": {
          "0": { value: 1, edited: true },
          "517": { value: 0.1, edited: true, curve: "easeOutBack" },
          "1083": { value: 1, edited: true }
        },
        "scale.y": {
          "0": { value: 1, edited: true },
          "517": { value: 0.1, edited: true, curve: "easeOutBack" },
          "1083": { value: 1, edited: true }
        },
        "rotation.z": 0
      },
      "haiku:Group-89ee3b0a18db93df": {
        fillRule: "nonzero",
        stroke: "none",
        strokeWidth: 1,
        fill: "none",
        opacity: 0.595479911,
        "translation.x": -2,
        "translation.y": -12
      },
      "haiku:wire-56fbdd91c1ff926c": {
        stroke: "#46B6D8",
        strokeWidth: 4,
        x: 2,
        y: 12,
        width: 216,
        height: 31
      },
      "haiku:Lg-9c421671b1e25234": {
        "sizeMode.x": 1,
        "style.position": "absolute",
        "style.margin": "0",
        "style.padding": "0",
        "style.border": "0",
        "translation.x": 124,
        "style.overflow": "visible",
        "sizeAbsolute.x": 47,
        "translation.y": 54,
        "sizeAbsolute.y": 49,
        "sizeMode.y": 1,
        "style.zIndex": 7,
        "translation.z": {
          "0": {
            value: Haiku.inject(function(lift) {
              return lift;
            }, "lift"),
            edited: true
          }
        },
        opacity: {
          "0": { value: 0, edited: true },
          "633": { value: 1, edited: true }
        },
        "scale.x": {
          "0": { value: 1, edited: true },
          "633": { value: 0.1, edited: true, curve: "easeOutBack" },
          "1200": { value: 1, edited: true },
          "1650": {
            value: 0.9990162551236971,
            edited: true,
            curve: "easeInBack"
          },
          "2067": { value: 1.4, edited: true, curve: "easeOutBack" },
          "2817": { value: 1, edited: true }
        },
        "scale.y": {
          "0": { value: 1, edited: true },
          "633": { value: 0.1, edited: true, curve: "easeOutBack" },
          "1200": { value: 1, edited: true },
          "1650": {
            value: 0.9990162551236971,
            edited: true,
            curve: "easeInBack"
          },
          "2067": { value: 1.4, edited: true, curve: "easeOutBack" },
          "2817": { value: 1, edited: true }
        },
        "rotation.z": {
          "0": { value: 0, edited: true },
          "1650": { value: 0, edited: true, curve: "easeOutCubic" },
          "2833": { value: 6.28, edited: true }
        }
      },
      "haiku:Group-d457482fe1904311": {
        fillRule: "nonzero",
        stroke: "none",
        strokeWidth: 1,
        fill: "none",
        opacity: 0.595479911,
        "translation.x": -31,
        "translation.y": -4
      },
      "haiku:lg-f0601ea0421756ac": {
        fill: "#00B9DC",
        x: 31,
        y: 4,
        width: 47,
        height: 49
      },
      "haiku:Md-3fff352007b79a38": {
        "style.overflow": "visible",
        "style.position": "absolute",
        "style.margin": "0",
        "style.padding": "0",
        "style.border": "0",
        "translation.x": 147.5,
        "translation.y": 72,
        "sizeAbsolute.x": 34,
        "sizeMode.x": 1,
        "sizeAbsolute.y": 35,
        "sizeMode.y": 1,
        "style.zIndex": 8,
        "translation.z": {
          "0": {
            value: Haiku.inject(function(lift) {
              return lift + 15;
            }, "lift"),
            edited: true
          }
        },
        opacity: {
          "0": { value: 0, edited: true },
          "733": { value: 1, edited: true }
        },
        "scale.x": {
          "0": { value: 1, edited: true },
          "733": { value: 0.1, edited: true, curve: "easeOutBack" },
          "1300": { value: 1, edited: true },
          "1817": {
            value: 0.9990162551236971,
            edited: true,
            curve: "easeInBack"
          },
          "2233": { value: 1.4, edited: true, curve: "easeOutBack" },
          "2983": { value: 1, edited: true }
        },
        "scale.y": {
          "0": { value: 1, edited: true },
          "733": { value: 0.1, edited: true, curve: "easeOutBack" },
          "1300": { value: 1, edited: true },
          "1817": {
            value: 0.9990162551236971,
            edited: true,
            curve: "easeInBack"
          },
          "2233": { value: 1.4, edited: true, curve: "easeOutBack" },
          "2983": { value: 1, edited: true }
        },
        "rotation.z": {
          "0": { value: 0, edited: true },
          "1817": { value: 0, edited: true, curve: "easeOutCubic" },
          "3000": { value: 6.28, edited: true }
        }
      },
      "haiku:Group-e37786700336b78c": {
        fillRule: "nonzero",
        stroke: "none",
        strokeWidth: 1,
        fill: "none",
        opacity: 0.595479911,
        "translation.x": -61,
        "translation.y": -29
      },
      "haiku:md-850076faf20fa172": {
        fill: "#00B9DC",
        x: 61,
        y: 29,
        width: 34,
        height: 35
      },
      "haiku:Sm-1cd3c90fbefe9674": {
        "style.overflow": "visible",
        "sizeAbsolute.x": 25,
        "style.margin": "0",
        "style.padding": "0",
        "style.border": "0",
        "translation.x": 240.053,
        "translation.y": 44.457,
        "style.position": "absolute",
        "rotation.z": {
          "0": { value: 0, edited: true },
          "1500": { value: 0, edited: true, curve: "easeOutCubic" },
          "2683": { value: 6.28, edited: true }
        },
        "sizeMode.x": 1,
        "sizeAbsolute.y": 26,
        "sizeMode.y": 1,
        "style.zIndex": 9,
        "translation.z": {
          "0": {
            value: Haiku.inject(function(lift) {
              return lift + 5;
            }, "lift"),
            edited: true
          }
        },
        opacity: {
          "0": { value: 0, edited: true },
          "733": { value: 1, edited: true }
        },
        "scale.x": {
          "0": { value: 1, edited: true },
          "733": { value: 0.1, edited: true, curve: "easeOutBack" },
          "1300": { value: 1, edited: true },
          "1500": {
            value: 0.9990162551236971,
            edited: true,
            curve: "easeInBack"
          },
          "1917": { value: 1.4, edited: true, curve: "easeOutBack" },
          "2667": { value: 1, edited: true }
        },
        "scale.y": {
          "0": { value: 1, edited: true },
          "733": { value: 0.1, edited: true, curve: "easeOutBack" },
          "1300": { value: 1, edited: true },
          "1500": {
            value: 0.9990162551236971,
            edited: true,
            curve: "easeInBack"
          },
          "1917": { value: 1.4, edited: true, curve: "easeOutBack" },
          "2667": { value: 1, edited: true }
        }
      },
      "haiku:Group-b038d3754ca586a2": {
        fillRule: "nonzero",
        stroke: "none",
        strokeWidth: 1,
        fill: "none",
        opacity: 0.595479911,
        "translation.x": -158,
        "translation.y": -6
      },
      "haiku:sm-92aff97357956a8d": {
        fill: "#00B9DC",
        x: 158,
        y: 6,
        width: 25,
        height: 26
      },
      "haiku:Shad-Wire-0a16d017ecb6539e": {
        "sizeMode.x": 1,
        "style.position": "absolute",
        "style.margin": "0",
        "style.padding": "0",
        "style.border": "0",
        "translation.x": 169.5,
        "style.overflow": "visible",
        "sizeAbsolute.x": 216,
        "translation.y": 66,
        "sizeAbsolute.y": 31,
        "sizeMode.y": 1,
        "style.zIndex": 2,
        opacity: {
          "0": { value: 0, edited: true },
          "517": { value: 1, edited: true }
        },
        "scale.x": {
          "0": { value: 1, edited: true },
          "517": { value: 0.1, edited: true, curve: "easeOutBack" },
          "1083": { value: 1, edited: true }
        },
        "scale.y": {
          "0": { value: 1, edited: true },
          "517": { value: 0.1, edited: true, curve: "easeOutBack" },
          "1083": { value: 1, edited: true }
        },
        "rotation.z": 0
      },
      "haiku:Group-f59c849a3558e028": {
        fillRule: "nonzero",
        stroke: "none",
        strokeWidth: 1,
        fill: "none",
        "translation.x": -2,
        "translation.y": -12
      },
      "haiku:shad_wire-2304666c6d0d61b6": {
        stroke: "#1A2125",
        strokeWidth: 4,
        x: 2,
        y: 12,
        width: 216,
        height: 31
      },
      "haiku:Shad-Lg-9b52ee502202d0ed": {
        "style.overflow": "visible",
        "style.position": "absolute",
        "style.margin": "0",
        "style.padding": "0",
        "style.border": "0",
        "translation.x": 114,
        "translation.y": 67,
        "sizeAbsolute.x": 47,
        "sizeMode.x": 1,
        "sizeAbsolute.y": 49,
        "sizeMode.y": 1,
        "style.zIndex": 3,
        opacity: {
          "0": { value: 0, edited: true },
          "633": { value: 1, edited: true }
        },
        "scale.x": {
          "0": { value: 1, edited: true },
          "633": { value: 0.1, edited: true, curve: "easeOutBack" },
          "1200": { value: 1, edited: true },
          "1650": {
            value: 0.9990162551236971,
            edited: true,
            curve: "easeInBack"
          },
          "2067": { value: 1.4, edited: true, curve: "easeOutBack" },
          "2817": { value: 1, edited: true }
        },
        "scale.y": {
          "0": { value: 1, edited: true },
          "633": { value: 0.1, edited: true, curve: "easeOutBack" },
          "1200": { value: 1, edited: true },
          "1650": {
            value: 0.9990162551236971,
            edited: true,
            curve: "easeInBack"
          },
          "2067": { value: 1.4, edited: true, curve: "easeOutBack" },
          "2817": { value: 1, edited: true }
        },
        "rotation.z": {
          "0": { value: 0, edited: true },
          "1650": { value: 0, edited: true, curve: "easeOutCubic" },
          "2833": { value: 6.28, edited: true }
        }
      },
      "haiku:Group-c0fbe2e8dd53e2b9": {
        fillRule: "nonzero",
        stroke: "none",
        strokeWidth: 1,
        fill: "none",
        "translation.x": -31,
        "translation.y": -4
      },
      "haiku:shad_lg-bd22fbc7151a37a7": {
        fill: "#1A2125",
        x: 31,
        y: 4,
        width: 47,
        height: 49
      },
      "haiku:Shad-Md-d1b159e720614de8": {
        "style.overflow": "visible",
        "sizeMode.x": 1,
        "style.margin": "0",
        "style.padding": "0",
        "style.border": "0",
        "translation.x": 137.5,
        "style.position": "absolute",
        "sizeAbsolute.x": 34,
        "translation.y": 85,
        "sizeAbsolute.y": 35,
        "sizeMode.y": 1,
        "style.zIndex": 4,
        opacity: {
          "0": { value: 0, edited: true },
          "733": { value: 1, edited: true }
        },
        "scale.x": {
          "0": { value: 1, edited: true },
          "733": { value: 0.1, edited: true, curve: "easeOutBack" },
          "1300": { value: 1, edited: true },
          "1817": {
            value: 0.9990162551236971,
            edited: true,
            curve: "easeInBack"
          },
          "2233": { value: 1.4, edited: true, curve: "easeOutBack" },
          "2983": { value: 1, edited: true }
        },
        "scale.y": {
          "0": { value: 1, edited: true },
          "733": { value: 0.1, edited: true, curve: "easeOutBack" },
          "1300": { value: 1, edited: true },
          "1817": {
            value: 0.9990162551236971,
            edited: true,
            curve: "easeInBack"
          },
          "2233": { value: 1.4, edited: true, curve: "easeOutBack" },
          "2983": { value: 1, edited: true }
        },
        "rotation.z": {
          "0": { value: 0, edited: true },
          "1817": { value: 0, edited: true, curve: "easeOutCubic" },
          "3000": { value: 6.28, edited: true }
        }
      },
      "haiku:Group-834021552e683c0c": {
        fillRule: "nonzero",
        stroke: "none",
        strokeWidth: 1,
        fill: "none",
        "translation.x": -61,
        "translation.y": -29
      },
      "haiku:shad_md-eede85319b8b02ca": {
        fill: "#1A2125",
        x: 61,
        y: 29,
        width: 34,
        height: 35
      },
      "haiku:Shad-Sm-e466e87790d59aa7": {
        "sizeAbsolute.x": 25,
        "style.position": "absolute",
        "style.margin": "0",
        "style.padding": "0",
        "style.border": "0",
        "translation.x": 230.053,
        "style.overflow": "visible",
        "rotation.z": {
          "0": { value: 0, edited: true },
          "1500": { value: 0, edited: true, curve: "easeOutCubic" },
          "2683": { value: 6.28, edited: true }
        },
        "translation.y": 57.457,
        "sizeMode.x": 1,
        "sizeAbsolute.y": 26,
        "sizeMode.y": 1,
        "style.zIndex": 5,
        opacity: {
          "0": { value: 0, edited: true },
          "733": { value: 1, edited: true }
        },
        "scale.x": {
          "0": { value: 1, edited: true },
          "733": { value: 0.1, edited: true, curve: "easeOutBack" },
          "1300": { value: 1, edited: true },
          "1500": {
            value: 0.9990162551236971,
            edited: true,
            curve: "easeInBack"
          },
          "1917": { value: 1.4, edited: true, curve: "easeOutBack" },
          "2667": { value: 1, edited: true }
        },
        "scale.y": {
          "0": { value: 1, edited: true },
          "733": { value: 0.1, edited: true, curve: "easeOutBack" },
          "1300": { value: 1, edited: true },
          "1500": {
            value: 0.9990162551236971,
            edited: true,
            curve: "easeInBack"
          },
          "1917": { value: 1.4, edited: true, curve: "easeOutBack" },
          "2667": { value: 1, edited: true }
        }
      },
      "haiku:Group-7f4d4d9afda41dd7": {
        fillRule: "nonzero",
        stroke: "none",
        strokeWidth: 1,
        fill: "none",
        "translation.x": -158,
        "translation.y": -6
      },
      "haiku:shad_sm-1023254ffb5a6bf8": {
        fill: "#1A2125",
        x: 158,
        y: 6,
        width: 25,
        height: 26
      }
    }
  },
  template: {
    elementName: "div",
    attributes: { "haiku-id": "Blue-14f1fd9b04f06ba5", "haiku-title": "Blue" },
    children: [
      {
        elementName: "svg",
        attributes: {
          version: "1.1",
          xmlns: "http://www.w3.org/2000/svg",
          "xmlns:xlink": "http://www.w3.org/1999/xlink",
          "haiku-id": "Shad-Sm-e466e87790d59aa7",
          "haiku-title": "shad_sm",
          "haiku-source":
            "designs/heroine.sketch.contents/slices/ui_blue.svg#shadow#shad_sm"
        },
        children: [
          {
            elementName: "g",
            attributes: { "haiku-id": "Group-7f4d4d9afda41dd7" },
            children: [
              {
                elementName: "rect",
                attributes: {
                  "haiku-id": "shad_sm-1023254ffb5a6bf8",
                  id: "shad_sm"
                },
                children: []
              }
            ]
          }
        ]
      },
      {
        elementName: "svg",
        attributes: {
          version: "1.1",
          xmlns: "http://www.w3.org/2000/svg",
          "xmlns:xlink": "http://www.w3.org/1999/xlink",
          "haiku-id": "Shad-Md-d1b159e720614de8",
          "haiku-title": "shad_md",
          "haiku-source":
            "designs/heroine.sketch.contents/slices/ui_blue.svg#shadow#shad_md"
        },
        children: [
          {
            elementName: "g",
            attributes: { "haiku-id": "Group-834021552e683c0c" },
            children: [
              {
                elementName: "rect",
                attributes: {
                  "haiku-id": "shad_md-eede85319b8b02ca",
                  id: "shad_md"
                },
                children: []
              }
            ]
          }
        ]
      },
      {
        elementName: "svg",
        attributes: {
          version: "1.1",
          xmlns: "http://www.w3.org/2000/svg",
          "xmlns:xlink": "http://www.w3.org/1999/xlink",
          "haiku-id": "Shad-Lg-9b52ee502202d0ed",
          "haiku-title": "shad_lg",
          "haiku-source":
            "designs/heroine.sketch.contents/slices/ui_blue.svg#shadow#shad_lg"
        },
        children: [
          {
            elementName: "g",
            attributes: { "haiku-id": "Group-c0fbe2e8dd53e2b9" },
            children: [
              {
                elementName: "rect",
                attributes: {
                  "haiku-id": "shad_lg-bd22fbc7151a37a7",
                  id: "shad_lg"
                },
                children: []
              }
            ]
          }
        ]
      },
      {
        elementName: "svg",
        attributes: {
          version: "1.1",
          xmlns: "http://www.w3.org/2000/svg",
          "xmlns:xlink": "http://www.w3.org/1999/xlink",
          "haiku-id": "Shad-Wire-0a16d017ecb6539e",
          "haiku-title": "shad_wire",
          "haiku-source":
            "designs/heroine.sketch.contents/slices/ui_blue.svg#shadow#shad_wire"
        },
        children: [
          {
            elementName: "g",
            attributes: { "haiku-id": "Group-f59c849a3558e028" },
            children: [
              {
                elementName: "rect",
                attributes: {
                  "haiku-id": "shad_wire-2304666c6d0d61b6",
                  id: "shad_wire"
                },
                children: []
              }
            ]
          }
        ]
      },
      {
        elementName: "svg",
        attributes: {
          version: "1.1",
          xmlns: "http://www.w3.org/2000/svg",
          "xmlns:xlink": "http://www.w3.org/1999/xlink",
          "haiku-id": "Sm-1cd3c90fbefe9674",
          "haiku-title": "sm",
          "haiku-source":
            "designs/heroine.sketch.contents/slices/ui_blue.svg#thing#sm"
        },
        children: [
          {
            elementName: "g",
            attributes: { "haiku-id": "Group-b038d3754ca586a2" },
            children: [
              {
                elementName: "rect",
                attributes: { "haiku-id": "sm-92aff97357956a8d", id: "sm" },
                children: []
              }
            ]
          }
        ]
      },
      {
        elementName: "svg",
        attributes: {
          version: "1.1",
          xmlns: "http://www.w3.org/2000/svg",
          "xmlns:xlink": "http://www.w3.org/1999/xlink",
          "haiku-id": "Md-3fff352007b79a38",
          "haiku-title": "md",
          "haiku-source":
            "designs/heroine.sketch.contents/slices/ui_blue.svg#thing#md"
        },
        children: [
          {
            elementName: "g",
            attributes: { "haiku-id": "Group-e37786700336b78c" },
            children: [
              {
                elementName: "rect",
                attributes: { "haiku-id": "md-850076faf20fa172", id: "md" },
                children: []
              }
            ]
          }
        ]
      },
      {
        elementName: "svg",
        attributes: {
          version: "1.1",
          xmlns: "http://www.w3.org/2000/svg",
          "xmlns:xlink": "http://www.w3.org/1999/xlink",
          "haiku-id": "Lg-9c421671b1e25234",
          "haiku-title": "lg",
          "haiku-source":
            "designs/heroine.sketch.contents/slices/ui_blue.svg#thing#lg"
        },
        children: [
          {
            elementName: "g",
            attributes: { "haiku-id": "Group-d457482fe1904311" },
            children: [
              {
                elementName: "rect",
                attributes: { "haiku-id": "lg-f0601ea0421756ac", id: "lg" },
                children: []
              }
            ]
          }
        ]
      },
      {
        elementName: "svg",
        attributes: {
          version: "1.1",
          xmlns: "http://www.w3.org/2000/svg",
          "xmlns:xlink": "http://www.w3.org/1999/xlink",
          "haiku-id": "Wire-731cb434286072ba",
          "haiku-title": "wire",
          "haiku-source":
            "designs/heroine.sketch.contents/slices/ui_blue.svg#thing#wire"
        },
        children: [
          {
            elementName: "g",
            attributes: { "haiku-id": "Group-89ee3b0a18db93df" },
            children: [
              {
                elementName: "rect",
                attributes: { "haiku-id": "wire-56fbdd91c1ff926c", id: "wire" },
                children: []
              }
            ]
          }
        ]
      },
      {
        elementName: "svg",
        attributes: {
          version: "1.1",
          xmlns: "http://www.w3.org/2000/svg",
          "xmlns:xlink": "http://www.w3.org/1999/xlink",
          "haiku-id": "Slot-5d608acbed0e538b",
          "haiku-title": "slot",
          "haiku-source":
            "designs/heroine.sketch.contents/slices/ui_blue.svg#slot"
        },
        children: [
          {
            elementName: "g",
            attributes: { "haiku-id": "Group-e0ec0adc46792211" },
            children: [
              {
                elementName: "rect",
                attributes: { "haiku-id": "slot-e4e182e2aa738bd6", id: "slot" },
                children: []
              }
            ]
          }
        ]
      }
    ]
  }
};



//////////////////
// WEBPACK FOOTER
// ./~/@haiku/taylor-heroine/code/blue/code.js
// module id = 517
// module chunks = 35783957827783